//API URL
export const API_URL = "https://api.hrbuddie.com";
// export const API_URL = "https://beta.api.hrbuddie.com";
// export const API_URL = "https://qa.api.hrms.hrbuddie.com";
// export const API_URL = "https://dev.api.hrms.hrbuddie.com";

// local server
// export const API_URL = "http://192.168.0.28:8000";

// authentication endpoints
export const LOGIN_URL = `/authentication/login/`;
export const LOGOUT_URL = `/authentication/logout/`;
export const FORGOT_PASSWORD = `/authentication/forgotpassword/`; // not found in hrbuddie endpoints
export const CHANGE_PASSWORD = `/authentication/changepassword/`;
export const SEND_OTP = `/authentication/send_otp/`;
export const VERIFY_OTP = `/authentication/verify_otp/`;

// home screen endpoints
export const HOME = `home/`;
export const HAPPYMETER = `home/happy_meter/`;
export const CLOCKIFY = `home/clockify/`;
export const NOTIFICATION = `home/notification/`;
export const NOTIFICATION_COUNT = `home/notification/count/`;

export const NEW_EMPLOYEE_ATTENDANCE_DAILY =  `attendance/`;
export const NEW_EMPLOYEE_ATTENDANCE_LOG = `attendance/attendance_log/`;
export const NEW_EMPLOYEE_ATTENDANCE_CORRECTION_REQUEST = `attendance/correction-request/`;

export const USERGROUP = 'administrator/user_group/'
export const USERPERMISSION = 'administrator/user_permissions/'
export const PASSWORD_POLICY = 'administrator/password_policy/'
export const NOTICE_BOARD = 'administrator/notice_board/'
export const EMPLOYER = 'administrator/company/';
export const ORGANIZATION_DOCUMENTS = 'administrator/documents'

// master
export const EMPLOYEE_TYPE = `master/employee_type/`;
export const EMPLOYEE_DEPARTMENT = `master/departments/`;
export const EMPLOYEE_DESIGNATION = `master/designation/`;
export const EMPLOYEE_GROUP = `master/group/`;
export const EMPLOYEE_LEAVE_POLICY = `master/leave_type/`;
export const REIMBURSEMENTS_CONFIG = `master/reimbursement_type/`;
export const ASSET_MANAGEMENT = `master/asset_type/`;
export const MASTER_ASSET_CATEGORY = `master/asset_category/`;
export const MASTER_ASSET_SUBCATEGORY = `master/asset_sub_category/`;
export const LETTER_TYPE_API = `master/letter_type/`;
export const LETTER_TEMPLATE_API = `master/letter_template/`;

// configuration
export const EMPLOYEE_SHIFT = 'configuration/shift/'
export const HOLIDAY_SETUP = 'configuration/holiday/'
export const EMPLOYEE_WEEK_OFF = 'configuration/weekoff/'
export const PAYROLL_PERIOD = 'configuration/payroll_period/'
export const SALARY_COMPONENT = 'configuration/salary_component/'
export const SALARY_TEMPLATE = 'configuration/salary_template/'
export const CUSTOM_CONFIGURATION = 'configuration/custom_configuration/'

// employee
export const EMPLOYEE_PERSONAL_INFO = `employee/info/`;
export const EMPLOYEEDOC = `employee/document/`;
export const EMPLOYEESAL = `employee/salary/`;
export const EMPLOYEEISSUEDDOC = `employee/document/issued/`;

export const EMPLOYEE_CANDIDATE_INFO = `employee/candidate/info/`;
export const EMPLOYEE_CANDIDATE_DOC = `employee/candidate/document/`
export const EMPLOYEE_CANDIDATE_SAL = `employee/candidate/salary/`
export const EMPLOYEE_CANDIDATE_ISSUEDDOC = ``; // --> this concept is skipped and handled in final stage of verification
export const EMPLOYEE_CANDIDATE_VERIFICATION = `employee/candidate/verification/`;
export const EMPLOYEE_CANDIDATE_OFFER_LETTER = `employee/offer_letter/`

export const EMPLOYEE_INTERN_INFO = `employee/interns/info/`;
export const EMPLOYEE_INTERN_DOC = `employee/interns/document/`
export const EMPLOYEE_INTERN_SAL = `employee/interns/salary/`
export const EMPLOYEE_INTERN_ISSUEDDOC = ``;  // --> this concept is skipped and handled in final stage of verification
export const EMPLOYEE_INTERN_VERIFICATION = `employee/interns/verification/`;
export const EMPLOYEE_INTERN_OFFER_LETTER = `employee/offer_letter/`

// employee request endpoints
export const LEAVE_URL = `employee/leave_request/`;
export const REIMBURSEMENT_URL = `employee/reimbursement_request/`;
export const ADVANCE_URL = `employee/advance_salary_request/`;
export const SUBORDINATES_URL = `employee/subordinates/employee_list/`;
export const SUBORDINATE_ATTENDANCE_SUMMARY_URL = `employee/subordinates/attendance_list/`;

// approval inbox
export const LEAVE_REQUEST_URL = 'employee/leave_approval/'
export const REIMBURESMENT_REQUEST_URL = 'employee/reimbursement_approval/'
export const ADVANCE_REQUEST_URL = 'employee/advance_salary_approval/'
export const RESIGNATION_REQUEST_URL = 'employee/resignation_approval/'

// payroll
export const PAYROLL_PROCESS = `payroll/payroll_process/`;
export const PAYROLL_RUN_GET = `payroll/run_payroll/`;
export const PAYROLL_PAYSLIP_EDIT = `/payroll/salary_edit/`
export const PAYROLL_PUBLISH = `payroll/publish_payslip/`;
export const PAYROLL_PAY_SLIP = `payroll/payslip/`;

// attendance
export const DAYWISE_ATTENDANCE = 'attendance'
export const MONTHWISE_ATTENDANCE_LOG = 'attendance/attendance_log/'
export const EMPLOYEE_ATTENDANCE_DAILY = 'attendance/'
export const EMPLOYEE_MISSING_ATTENDANCE_CORRECTION = 'attendance/correction-request/'

// assets
export const ASSET_REGISTRY = `asset_management/asset_registry/`;
export const ASSET_EMPLOYEE_AUDIT = `asset_management/employee_audit/`;
//asset registry city - floor - block - room 
export const ASSET_CITY = `asset_management/asset_city/`;
export const ASSET_BLOCK = `asset_management/asset_block/`;
export const ASSET_FLOOR = `asset_management/asset_floor/`;
export const ASSET_ROOM = `asset_management/asset_room/`;

// roster
export const ROSTERING_GET = `rostering/`;
export const INDIVIDUAL_ROSTERING_GET = `rostering/rostering_rotational_shift/`;

// reports
export const DAYWISE_ATTENDANCE_REPORTS = 'reports/attendance/day/'
export const MONTHWISE_ATTENDANCE_REPORTS = 'reports/attendance/month/'
export const SALARYPROCESS_BANK_REPORTS = 'reports/bank/'
export const SALARYSUMMARY_REPORTS = 'reports/salary_summary/'
export const PAYROLL_DETAIL_REPORTS = 'reports/payroll/'
export const EMPLOYEE_ESI_REPORTS = 'reports/esi/'
export const EMPLOYEE_PF_REPORTS = 'reports/pf/'
export const MUSTER_ROLL_REPORT = 'reports/muster_roll/'
export const EMPLOYEE_CREDIT_DEBIT = 'reports/credit_debit/'
export const EMPLOYEE_ATTENDANCE_CORRECTION = 'reports/attendance/correction/'
export const SUBORDINATES_REPORTS = 'reports/subordinates/'
export const ROSTERING_REPORT = 'reports/roster_report/'
export const LEAVE_PERMISSION_REPORT = 'reports/approved_leaves_report/'

// settings
export const SETTINGS_CHANGE_PASSWORD = 'employee/password/change/'